// PaymentMethodsSection.js
import React from 'react';

const PaymentMethodsSection = ({ activeSection }) => (
  <div
    id="payment-methods-card"
    className={`bg-white rounded-lg shadow-lg p-6 transition-all ease-in-out duration-300 ${
      activeSection === 'paymentMethods' ? 'border' : ''
    }`}
  >
    <h1 className="text-xl font-bold text-gray-900">Payment Methods</h1>
    <p className="text-gray-600 mt-2">Manage your saved payment methods here.</p>
    {/* Placeholder content for payment methods */}
    <div className="mt-6 space-y-4">
      <div className="flex justify-between items-center border-b py-2">
        <span className="text-gray-700">Visa Ending in 1234</span>
        <span className="text-gray-900 font-semibold">Expires: 12/24</span>
      </div>
      <div className="flex justify-between items-center border-b py-2">
        <span className="text-gray-700">MasterCard Ending in 5678</span>
        <span className="text-gray-900 font-semibold">Expires: 08/25</span>
      </div>
      {/* Additional payment methods can go here */}
    </div>
  </div>
);

export default PaymentMethodsSection;
